import React from "react";
import { Scatter } from "recharts";
import PropTypes from "prop-types";

const addJitter = (arr, jitterKey, categoryNum, jitterVar) => {
  return arr.map((item) => {
    let rand = Math.random() * jitterVar;
    // determine if positive or negative
    rand = Math.random() > 0.5 ? rand * -1 : rand * 1;
    // round to 2 dp
    rand = Math.round(rand * 100) / 100;
    return {
      ...item,
      [jitterKey]: categoryNum + rand,
    };
  });
};

const ScatterJitter = ({
  label,
  jitterKey,
  categoryVal,
  fill,
  data,
  jitterVar,
}) => {
  const dataWithJitter = addJitter(data, jitterKey, categoryVal, jitterVar);
  return <Scatter key={label} name={label} data={dataWithJitter} fill={fill} />;
};

ScatterJitter.propTypes = {
  label: PropTypes.string.isRequired,
  jitterKey: PropTypes.string.isRequired,
  categoryVal: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  jitterVar: PropTypes.number.isRequired,
};
export default ScatterJitter;
